<template>
	<div>
		<b-modal
			v-if="!viewModal"
			id="mobile-select-exis-doc"
			v-model="showModal"
			no-close-on-backdrop
			centered
			hide-footer
			hide-header
			@show="filterDocList"
			@hidden="closemodal"
		>
			<div>
				<div class="candash-modal-top mb-grey-txt-3 p-3">
					Select from existing
					<img
						@click="closemodal"
						class="rotate-on-hover"
						src="@/assets/newdesign/dashboard/blueCross.svg"
						alt=""
					/>
				</div>
				<div class="p-1">
					<div class="border-bottom scroll-container">
						<div class="scroll-inner">
							<div
								v-for="(doc, ind) in documentList"
								:key="doc.categoryID"
								:class="[
									activeCategoryIndex === ind
										? 'mobjd-sel-tab'
										: 'mobjd-unsel-tab',
								]"
								@click="activeCategoryIndex = ind"
							>
								{{ doc.categoryTitle }}
								<div class="mobjd-sel-line"></div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="mobjd-selectexisting-overflow"
					v-if="documentList[activeCategoryIndex]"
				>
					<div
						v-for="(subDoc, i) in documentList[activeCategoryIndex].documents ||
						[]"
						:key="i"
					>
						<div
							v-if="subDoc.document != null"
							class="d-flex align-items-center mob-radio-group mt-2"
						>
							<b-form-radio
								v-if="!allowMultiple"
								v-model="selectedDocIndex"
								:value="subDoc.document.documentID"
								@change="selectTheDocuments(subDoc)"
							/>
							<b-form-checkbox
								v-else
								class="dynamic-check"
								v-model="selectedDocIndexMultiple"
								:value="subDoc.document.documentID"
								@change="handleCheckboxChange(subDoc)"
							/>
							<div class="mobjd-existind-doc-card">
								<div class="w65 text-truncate">{{ subDoc.documentName }}</div>
								<div class="d-flex align-items-center">
									<div
										:class="
											getType(subDoc.document.documentSource[0]) !== 'pdf'
												? 'opac-5 not-allowed'
												: 'pointer'
										"
										@click="
											getType(subDoc.document.documentSource[0]) !== 'pdf'
												? ''
												: openPreview(subDoc.document)
										"
									>
										<img
											src="@/assets/icons/mobUpldDoc/preview-mob.svg"
											alt=""
										/>
									</div>
									<div class="jdp-modal-vertical-line ml-2 mr-2"></div>
									<div
										class="pointer"
										@click="openTemplateLink(subDoc.document.documentSource[0])"
									>
										<img
											src="@/assets/newdesign/jdprogress/mobjdprog/mobileDownload.svg"
											alt=""
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div
						v-for="subDoc in documentList[activeCategoryIndex].otherDocuments ||
						[]"
						:key="subDoc.documentID"
						class="d-flex align-items-center mob-radio-group mt-2"
					>
						<b-form-radio
							v-if="!allowMultiple"
							v-model="selectedDocIndex"
							:value="subDoc.documentID"
							@change="selectTheDocuments(subDoc)"
						/>
						<b-form-checkbox
							class="dynamic-check"
							v-else
							v-model="selectedDocIndexMultiple"
							:value="subDoc.documentID"
							@change="handleCheckboxChange(subDoc)"
						/>
						<div class="mobjd-existind-doc-card">
							<div class="w65 text-truncate">{{ subDoc.documentName }}</div>
							<div class="d-flex align-items-center">
								<div
									:class="
										getType(subDoc.documentSource[0]) !== 'pdf'
											? 'opac-5 not-allowed'
											: 'pointer'
									"
									@click="
										getType(subDoc.documentSource[0]) !== 'pdf'
											? ''
											: openPreview(subDoc)
									"
								>
									<img src="@/assets/icons/mobUpldDoc/preview-mob.svg" alt="" />
								</div>
								<div class="jdp-modal-vertical-line ml-2 mr-2"></div>
								<div @click="openTemplateLink(subDoc.documentSource[0])">
									<img
										src="@/assets/newdesign/jdprogress/mobjdprog/mobileDownload.svg"
										alt=""
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					class="candash-modal-footer d-flex align-items-center justify-content-center"
				>
					<div class="width-120px candash-cancelBtn mr-3" @click="closemodal">
						Cancel
					</div>
					<b-button class="width-120px candash-addBtn" @click="selectDocuments">
						Select
					</b-button>
				</div>
			</div>
		</b-modal>
		<PreviewDocumentMob
			v-if="viewModal"
			:pdfLink="pdfLink"
			@showDoc="(viewModal = false), $emit('change-mob-preview', false)"
		/>
	</div>
</template>

<script>
import PreviewDocumentMob from "@/components/MobileComponents/Documents/PreviewDocument.vue";
export default {
	props: {
		showModal: Boolean,
		allowMultiple: Boolean,
		docList: Array,
	},
	components: {
		PreviewDocumentMob,
	},
	data() {
		return {
			// OBJECTS
			pdfLink: {
				name: "",
				link: "",
			},

			// BOOLEAN
			viewModal: false,

			// ARRAYS
			selectedDocs: [],
			selectedDocIndexMultiple: [],
			documentList: [],

			// NUMBERS
			selectedDocIndex: null,
			activeCategoryIndex: 0,
			numPages: 0,
			currentPage: 1,
		};
	},
	methods: {
		filterDocList() {
			this.documentList = this.docList.filter((category) => {
				const hasValidDocument = category.documents.some(
					(doc) => doc.document !== null
				);
				const hasOtherDocuments =
					category.otherDocuments && category.otherDocuments.length > 0;
				return hasValidDocument || hasOtherDocuments;
			});
		},
		selectTheDocuments(subDoc) {
			this.selectedDocs = [];
			if (subDoc.hasOwnProperty("document")) {
				this.selectedDocs.push({
					link: subDoc.document.documentSource[0],
					path: subDoc.document.path[0],
				});
			} else {
				this.selectedDocs.push({
					link: subDoc.documentSource[0],
					path: subDoc.path[0],
				});
			}
		},
		handleCheckboxChange(subDoc) {
			const docId = subDoc.document?.documentID || subDoc.documentID;

			const existingIndex = this.selectedDocs.findIndex(
				(doc) => doc.id === docId
			);

			if (existingIndex > -1) {
				// Deselect if already selected
				this.selectedDocs.splice(existingIndex, 1);
			} else {
				// Add if not present
				const link =
					subDoc.document?.documentSource?.[0] || subDoc.documentSource?.[0];
				const path = subDoc.document?.path?.[0] || subDoc.path?.[0];

				this.selectedDocs.push({
					id: docId,
					link,
					path,
				});
			}
		},
		getType(link) {
			const url = new URL(link);
			const pathname = url.pathname;
			const fileExtension = pathname.split(".").pop().toLowerCase();

			return fileExtension;
		},
		openPreview(doc) {
			this.pdfLink = {
				name: doc.documentName,
				link: doc.documentSource[0],
			};
			this.viewModal = true;
			this.$emit("change-mob-preview", true);
		},
		openTemplateLink(link) {
			const url = link;
			if (url) window.open(url, "_self");
		},
		closemodal() {
			this.$emit("close-modal");
		},
		selectDocuments() {
			this.$emit("sel-docs", this.selectedDocs);
		},
	},
};
</script>

<style scoped></style>
